export default function isZipCodeValid(zip) {
  return /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/.test(zip)
}
